<template>
  <!-- 添加一个场景页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <!-- 自动触发值 -->
      <config-hang
        v-for="(value, index) in serveShowData"
        :key="value.keyId"
        :inputID="value.keyId"
        @click.native.stop="imgChangeBtnHandle(value)"
      >
        <span slot="config_hang_ele2">自定义{{ index + 1 }}</span>
        <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
        <img
          v-if="value.keyId === imgState"
          slot="config_hang_xiugai"
          @click.stop="imgQueRenBtnHandle(value)"
          src="~assets/img/config/duihao.png"
          alt
        />
        <img
          v-else
          slot="config_hang_xiugai"
          src="~assets/img/config/xiugai.png"
          alt
        />
        <input
          type="text"
          slot="config_hang_input_right"
          :id="value.keyId"
          placeholder="请输入显示文字"
          v-model="value.moviesName"
        />
      </config-hang>

      <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">
        返回
      </div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
// import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data() {
    return {
      serveShowData: [
        {
          keyId: '15',
          moviesKey: 21,
          moviesName: ''
        },
        {
          keyId: '16',
          moviesKey: 22,
          moviesName: ''
        },
        {
          keyId: '17',
          moviesKey: 23,
          moviesName: ''
        },
        {
          keyId: '18',
          moviesKey: 24,
          moviesName: ''
        },
        {
          keyId: '19',
          moviesKey: 25,
          moviesName: ''
        },
        {
          keyId: '20',
          moviesKey: 26,
          moviesName: ''
        },
        {
          keyId: '21',
          moviesKey: 27,
          moviesName: ''
        },
        {
          keyId: '22',
          moviesKey: 28,
          moviesName: ''
        },
        {
          keyId: '23',
          moviesKey: 29,
          moviesName: ''
        }
      ], ////服务端返回的需要展示的数据
      imgState: ''
    }
  },
  computed: {},
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    saveReturnBtnHandle() {
      this.$router.go(-1)
    },
    imgChangeBtnHandle(value) {
      console.log('111111')
      this.imgState = value.keyId
    },
    imgQueRenBtnHandle(value) {
      console.log('2222')

      ///修改影视自定义按键名称 接口，获取数据
      this.$request({
        method: 'post',
        url: '/device/updateCustomKeyById',
        data: {
          token: this.$store.state.token,
          keyId: value.keyId,
          moviesName: value.moviesName
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveShowData = res.data.data ////拿到服务器返回的数据结果
            // console.log(res.data.data)
            // this.$store.dispatch('asyUpdataconfig019PageData', res.data.data) ///异步提交信息到仓库
            // 跳转页面
            this.imgState = ''
            console.log(res.data.data)

            // this.$router.go(-1)
            this.$showTipsToast(1, '修改成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  watch: {},
  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    ///获取影视自定义按键列表 接口，获取数据
    this.$request({
      method: 'post',
      url: '/device/findCustomKeyList',
      data: {
        token: this.$store.state.token,
        deviceId: this.$route.query.deviceId
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveShowData = res.data.data ////拿到服务器返回的数据结果
          console.log(res.data.data)
          // this.$store.dispatch('asyUpdataconfig019PageData', res.data.data) ///异步提交信息到仓库
          // 跳转页面
          // 对数据进行排序避免显示错乱
          this.serveShowData.sort(function(a, b) {
            return a.moviesKey - b.moviesKey
          })
          console.log(res.data.data)

          // this.$router.go(-1)
          // this.$showTipsToast(1, '设置成功', true) ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style></style>
